export const AUTH_FAILURE_QUERY_PARAM = 'login_error'

export const LOGIN_ERROR_DETAILED_MESSAGES: Record<string, string> = {
  generic: 'Sign-in failed with an unspecified error.',
  login_failed:
    'Sign-in failed. Joker redirected with the generic fallback code (no specific failure was provided).',
  passport_error:
    'Passport B2C authentication failed with a technical error during auth/verify.',
  passport_no_user:
    'B2C returned no user after auth/verify. The account may not exist, credentials may be invalid, or the token was rejected.',
  oauth_state_invalid:
    'OAuth state/nonce mismatch or expired sign-in session during auth/verify. Joker could not validate the callback or recover the session.',
  no_selected_account:
    'Session build completed but no selected account was resolved. Typical on user-context when requireSelectedAccount is true.',
  no_stores:
    'Selected account has no stores in the active country registry (NoStoresForAccountError). Account fallback was exhausted during auth/verify.',
  no_default_store:
    'Selected account has no usable default store (MissingDefaultStoreError). defaultStore.storeId is missing.',
  session_build_failed:
    'Unexpected error during session build in auth/verify (attachSessionContext).',
  session_persist_failed:
    'B2C sign-in succeeded but req.logIn() failed to persist the Express session during auth/verify.',
  verify_failed: 'Unhandled error in the auth/verify handler.',
  post_login_failed:
    'Post-login flow failed in auth/success (T&C, cookies, redirects, or downstream microservice calls).',
}

export const LOGIN_ERROR_MESSAGES_BY_LANGUAGE: Record<string, string> = {
  de: 'Beim Anmelden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  en: 'Something went wrong while signing you in. Please try again.',
  es: 'Algo salió mal al iniciar sesión. Por favor, inténtalo de nuevo.',
  fil: 'May nangyaring mali habang nag-sign in. Pakisubukang muli.',
  fr: 'Une erreur est survenue lors de la connexion. Veuillez réessayer.',
  id: 'Terjadi kesalahan saat masuk. Silakan coba lagi.',
  ko: '로그인 중 문제가 발생했습니다. 다시 시도해 주세요.',
  ms: 'Berlaku ralat semasa log masuk. Sila cuba lagi.',
  nl: 'Er is iets misgegaan bij het inloggen. Probeer het opnieuw.',
  pt: 'Algo deu errado ao fazer login. Por favor, tente novamente.',
  sw: 'Hitilafu ilitokea wakati wa kuingia. Tafadhali jaribu tena.',
  th: 'เกิดข้อผิดพลาดขณะเข้าสู่ระบบ โปรดลองอีกครั้ง',
  vi: 'Đã xảy ra lỗi khi đăng nhập. Vui lòng thử lại.',
  zh: '登录时出现问题，请重试。',
}
